// Global storage for free trial product IDs
window.freeTrialProductIds = window.freeTrialProductIds || [];

document.addEventListener('DOMContentLoaded', () => {
  const addFreeTrial = document.getElementById('free-trial');
  const freeTrialCheckboxes = document.querySelectorAll('input[name="freeTrial"]');
  
  let isFreeTrialChecked = Array.from(freeTrialCheckboxes).some(cb => cb.checked);
  
  // Store free trial product IDs from current page
  const currentPageFreeTrialIds = Array.from(document.querySelectorAll('.free-trial-offer')).map(el => {
    const variantId = el.dataset.variantId;
    return variantId ? parseInt(variantId) : null;
  }).filter(id => id !== null);
  

  currentPageFreeTrialIds.forEach(id => {
    if (!window.freeTrialProductIds.includes(id)) {
      window.freeTrialProductIds.push(id);
    }
  });
  
  freeTrialCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', (e) => {
      isFreeTrialChecked = Array.from(freeTrialCheckboxes).some(cb => cb.checked);
    });
  });

  const originalFetch = window.fetch;

  const getSelectedFreeTrialVariantIds = () => {
    const selectedCheckboxes = document.querySelectorAll('input[name="freeTrial"]:checked');
    const variantIds = [];
    
    selectedCheckboxes.forEach(checkbox => {
      const offerContainer = checkbox.closest('.free-trial-offer');
      if (offerContainer) {
        const variantId = offerContainer.dataset.variantId;
        if (variantId) {
          variantIds.push(parseInt(variantId));
        }
      }
    });
    
    return variantIds;
  };

  const removeFreeTrialProducts = async () => {
    try {
      const cart = await originalFetch('/cart.js').then(r => r.json());
      
      // Get all free trial product IDs from global storage and current page
      const allFreeTrialIds = [...window.freeTrialProductIds];
      
      // If we have cart items but no free trial IDs, try to identify them by price or other characteristics
      if (allFreeTrialIds.length === 0 && cart.items.length > 0) {
        // Look for items that might be free trial products (e.g., $0 price or specific titles)
        const potentialFreeTrialItems = cart.items.filter(item => {
          // Check if price is 0 or very low (free trial products are often $0)
          const isFreeOrLowPrice = item.price === 0 || item.price < 1000; // Less than $10
          
          // Check if title contains keywords that suggest it's a free trial
          const title = item.product_title.toLowerCase();
          const isFreeTrialTitle = title.includes('free') || 
                                  title.includes('trial') || 
                                  title.includes('sample') ||
                                  title.includes('18Birdies') ||
                                  title.includes('bonus');
          
          return isFreeOrLowPrice || isFreeTrialTitle;
        });
        
        if (potentialFreeTrialItems.length > 0) {
          const potentialFreeTrialIds = potentialFreeTrialItems.map(item => item.variant_id);
          allFreeTrialIds.push(...potentialFreeTrialIds);
        }
      }
      
      const hasMainProducts = cart.items.some(item => !allFreeTrialIds.includes(item.variant_id));
      const hasFreeTrialProducts = cart.items.some(item => allFreeTrialIds.includes(item.variant_id));
      
      if (hasFreeTrialProducts && !hasMainProducts) {
        const cartDrawerEl = document.querySelector('hdt-cart-drawer');
        if (!cartDrawerEl) {
          return;
        }
        const sectionId = cartDrawerEl.getAttribute('section-id');
        if (!sectionId) {
          return;
        }
        
        const freeTrialProductsInCart = cart.items.filter(item => 
          allFreeTrialIds.includes(item.variant_id)
        );
        
        let lastRemovalResult = null;
        for (const item of freeTrialProductsInCart) {
          const individualFormData = new FormData();
          individualFormData.set('id', item.variant_id);
          individualFormData.set('quantity', 0);
          individualFormData.set('sections', sectionId);
          
          const individualResponse = await originalFetch(`/cart/change.js`, {
            method: 'POST',
            body: individualFormData,
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          
          if (!individualResponse.ok) {
            continue;
          }
          
          const individualResult = await individualResponse.json();
          lastRemovalResult = individualResult;
        }
        
        const finalCart = await originalFetch('/cart.js').then(r => r.json());
        
        if (lastRemovalResult && lastRemovalResult.sections) {
          finalCart.sections = lastRemovalResult.sections;
        }
        
        document.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "line-item:change",
            cart: finalCart
          }
        }));
      }
    } catch (err) {
      console.error('Error removing free trial products:', err);
    }
  };

  const addMultipleFreeTrialProducts = async (variantIds) => {
    try {
      const cartDrawerEl = document.querySelector('hdt-cart-drawer');
      if (!cartDrawerEl) {
        return;
      }
      const sectionId = cartDrawerEl.getAttribute('section-id');
      if (!sectionId) {
        return;
      }

      const formData = new FormData();
      
      variantIds.forEach((variantId, index) => {
        formData.set(`items[${index}][id]`, variantId);
        formData.set(`items[${index}][quantity]`, 1);
      });
      
      formData.set('sections', sectionId);
      
      const response = await originalFetch(`${window.location.origin}/cart/add.js`, {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      const updatedCart = await originalFetch('/cart.js').then(r => r.json());
      updatedCart.sections = result.sections;
      
      document.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          actionAfterATC: formData.get("action_added") || 'open_cart_drawer',
          cart: updatedCart
        }
      }));
      
    } catch (error) {
      console.error('Failed to add trial products or update cart:', error);
    }
  };

  window.fetch = async (...args) => {
    try {
      if (args[0] && typeof args[0] === 'string' && args[0].includes('/cart/add.js')) {
        const response = await originalFetch(...args);
        
        if (response.ok && freeTrialCheckboxes.length > 0) {
          try {
            const getCartContents = await originalFetch('/cart.js').then(r => r.json());
            const selectedFreeTrialIds = getSelectedFreeTrialVariantIds();
            
            const variantsToAdd = selectedFreeTrialIds.filter(variantId => 
              !getCartContents.items.some(item => item.id === variantId)
            );
            
            if (variantsToAdd.length > 0 && isFreeTrialChecked) {
              await addMultipleFreeTrialProducts(variantsToAdd);
              
              const finalCart = await originalFetch('/cart.js').then(r => r.json());
              const modifiedResponse = new Response(JSON.stringify(finalCart), {
                status: 200,
                statusText: 'OK',
                headers: response.headers
              });
              
              return modifiedResponse;
            }
          } catch (error) {
            console.error('Error processing free trial products:', error);
          }
        }
        
        return response;
      }
      
      return originalFetch(...args);
    } catch (error) {
      console.error('Error in fetch override:', error);
      return originalFetch(...args);
    }
  };

  document.addEventListener('cart:change', async (e) => {
    await removeFreeTrialProducts();
  });

  // Run removal check after a short delay to ensure page is fully loaded
  setTimeout(() => {
    removeFreeTrialProducts();
  }, 100);
});